import copy from './copy'
import clear from './clear'
import build from './build'

export default {
  copy, clear, build
}
